// CameraContext.js
import React, { createContext, useContext } from 'react';
import { setMoveToCamera as realSetMoveToCamera } from './three/Camera'

// 2025.02.24일 기준 기본값으로 setMoveToCamera에 빈 함수 부분을 실제 함수로 대체
const defaultCameraContext = {
  setMoveToCamera: (...args) => {
    realSetMoveToCamera(...args);
  },
  setCameraActions: () => { },
};

export const CameraContext = createContext(defaultCameraContext);

export const useCamera = () => useContext(CameraContext);